import { apiFetch } from "@/lib/api";
import {
  Notification,
  NotificationQueryDto,
  NotificationResponse,
  UnreadCountResponse,
} from "../types/notification.types";

export const notificationApi = {
  async getAll(params?: NotificationQueryDto): Promise<NotificationResponse> {
    const searchParams = new URLSearchParams();

    if (params?.page) searchParams.set("page", params.page.toString());
    if (params?.limit) searchParams.set("limit", params.limit.toString());
    if (params?.read !== undefined) {
      searchParams.set("read", params.read.toString());
    }
    if (params?.type) searchParams.set("type", params.type);
    if (params?.sortBy) searchParams.set("sortBy", params.sortBy);
    if (params?.sortOrder) searchParams.set("sortOrder", params.sortOrder);

    const queryString = searchParams.toString();
    const url = queryString
      ? `/notifications?${queryString}`
      : "/notifications";

    return apiFetch(url);
  },

  async getUnreadCount(): Promise<UnreadCountResponse> {
    return apiFetch("/notifications/unread-count");
  },

  async markAsRead(id: string): Promise<Notification> {
    return apiFetch(`/notifications/${id}/read`, {
      method: "PATCH",
    });
  },

  async markAllAsRead(): Promise<{ message: string }> {
    return apiFetch("/notifications/read-all", {
      method: "PATCH",
    });
  },
};
